import axios from "axios";

// 创建axios实例
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "http://localhost:5000/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  async (config) => {
    const { useUserStore } = await import("@/stores/user");
    const userStore = useUserStore();
    if (userStore.tokens?.accessToken) {
      config.headers.Authorization = `Bearer ${userStore.tokens.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 如果后端返回了统一的响应格式 { success: true, data: ... }
    if (res && typeof res === "object" && "success" in res && "data" in res) {
      if (res.success) {
        return res.data;
      } else {
        return Promise.reject(new Error(res.message || "请求失败"));
      }
    }
    return res;
  },
  async (error) => {
    const res = error.response?.data;
    const message = res?.message || error.message || "请求失败";
    const status = error.response?.status;
    const url: string = error.config?.url || "";
    const isAuthRequest =
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/refresh") ||
      url.includes("/auth/profile") ||
      url.includes("/auth/logout");

    const err: any = new Error(message);
    err.status = status;
    err.code = status;
    err.data = res;

    if (status === 401) {
      if (!isAuthRequest) {
        const { useUserStore } = await import("@/stores/user");
        const userStore = useUserStore();
        userStore.logout();
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(err);
  },
);

export default apiClient;
